import { Component, ViewChild } from '@angular/core';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { CompaniesSummaryComponent } from '../companies-summary/companies-summary.component';
import { CompaniesDataComponent } from '../companies-data/companies-data.component';
import { DialogService } from 'src/app/core/dialog.service';
import { CompaniesFilterDialogComponent } from '../companies-filter-dialog/companies-filter-dialog.component';
import { ListCompaniesParams } from 'src/app/core/companies.service';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
})
export class CompaniesComponent {
  @ViewChild(CompaniesSummaryComponent)
  summary_component?: CompaniesSummaryComponent;
  @ViewChild(CompaniesDataComponent) data_component?: CompaniesDataComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(
    NavigationItemLabel.companies,
  );
  filters?: ListCompaniesParams;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private meta: Meta,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onRefresh(): void {
    this.onFilterClear({});
    this.summary_component?.onRefresh();
    //this.data_component?.onRefresh();
  }

  onFilter(): void {
    this.dialog_service
      .openDialog(CompaniesFilterDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.params) {
          this.filters = dialog_result.params;
          this.setDataFilters();
        }
      });
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  onFilterClear(filters: ListCompaniesParams): void {
    this.filters = filters;
    this.setDataFilters();
  }

  setDataFilters(): void {
    if (this.areFiltersSet()) {
      this.data_component?.onFilter(this.filters);
    }

    if (!this.areFiltersSet()) {
      this.data_component?.onFilter();
    }
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  areFiltersSet(): boolean {
    if (!this.filters) return false;

    const active_filters = Object.keys(this.filters).filter(k => {
      if (!this.filters) return false;
      return this.filters[k as keyof typeof this.filters] != null;
    });

    return active_filters && active_filters.length ? true : false;
  }
}
